<template>
    <div>
        <b><span>
            Presión barométrica actual: {{ ultima_presion }} mmHg
        </span></b>
        <br>
        <span>
            Presión barométrica máxima (últimas 24 horas): {{ presion_maxima }} mmHg
        </span>
        <br>
        <span>
            Presión barométrica media (últimas 24 horas): {{ presion_media }} mmHg
        </span>
        <br>
        <span>
            Presión barométrica mínima (últimas 24 horas): {{ presion_minima }} mmHg
        </span>
        <br>
        <span>
            Datos recuperados: {{ datos_recuperados }}%
        </span>
        <br>
        <span>
            Última transmisión: {{ ultima_transmision }}
        </span>
        <Graph 
            chart-title="Presión barométrica (últimas 24 horas)"
            :data-series="pressures" 
            :yleyend="'Presión barométrica (mmHg)'" 
            :xleyend="leyend" 
            :id-div="5+index"
        />
    </div>
</template>

<script>

    import Graph from '../Graphs/Graph.vue';

    export default {
        name: 'Pressure',

        components:{
            Graph
        },

        props:{
            charts: [],
            index: Number
        },

        data() {
            return{
                ultima_presion: 0,
                ultima_transmision: '',
                presion_maxima: 0,
                presion_media: 0,
                presion_minima: 0,
                datos_recuperados: 0,
                pressures: [],
                leyend: []
            }
        },

        created(){
            this.Get_Pressions();
        },

        methods: {
            /*
            * Se calculan los datos que no son nulos y se almacena su fecha y hora
            * Aquí se crea el array para constuir las series de las gráficas y el eje horizontal
            */
            Get_Pressions(){
                const datos = [];
                let suma = 0;

                for(var i in this.charts){
                    let presion = parseFloat(this.charts[i].presure);

                    if(!isNaN(presion)){
                        datos.push(parseFloat(presion.toFixed(1)));
                        this.leyend.push(this.charts[i].date+"<br/>"+this.charts[i].time);
                        suma += presion;
                    }
                }

                this.presion_maxima = Math.max.apply(null,datos).toFixed(1);
                this.presion_media = (suma/datos.length).toFixed(1);
                this.presion_minima = Math.min.apply(null,datos).toFixed(1);
                this.ultima_presion = datos[datos.length-1].toFixed(1);
                let fecha_hora = this.leyend[this.leyend.length -1];
                this.ultima_transmision = fecha_hora.replace('<br/>',' ');

                this.datos_recuperados = (datos.length*100/this.charts.length).toFixed(1);

                /*
                * Estos son los datos que se envían para constuir la gráfica
                * el tipo de gráfica, el nombre de la serie, el color y los datos de las series.
                */
                this.pressures = [{
                    type: "line",
                    name: "Presión barométrica (mmHg)",
                    color: "rgb(237, 126, 47, 0.8)",
                    data: datos
                }];
            }
        }
    };
</script>
